import { render, staticRenderFns } from "./categoryBadges.vue?vue&type=template&id=356230f7&"
import script from "./categoryBadges.vue?vue&type=script&lang=js&"
export * from "./categoryBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports